import QueryBusinessLookup from '../graphql/queries/QueryBusinessLookup';

export default {
  methods: {
    searchCompanies: async function ({ param, region }) {
      const { data: getBusinessInfo } = await this.$apollo.query({
        query: QueryBusinessLookup,
        debounce: 300,
        fetchPolicy: 'network-only',
        variables: { param, region }
      });

      return getBusinessInfo.getBusinessInfo;
    }
  }
};
